/* eslint import/prefer-default-export: "off" */
import type { State } from '@src/redux/configureStore'
import type { ShadowAccess } from '@src/redux/reducers/external.lists/default.state'

export const getIsLoading = (state: State) => state.externalLists.isPending
export const getShadowAccessLists = (state: State) =>
  state.externalLists.shadowAccessLists || ({} as ShadowAccess)
